import { useTranslation } from 'react-i18next'

import Button from '../../Button'

import * as styles from './WidgetPipelineActions.module.css'

function WidgetPipelineActions({
  backButtonProps,
  className = styles.WidgetPipelineActions,
  disabled,
  index,
  isLoading,
  itemsLength,
  onClickPrevious,
}) {
  const { t } = useTranslation()

  function handleClickPrevious() {
    return onClickPrevious(index)
  }

  return (
    <div className={className}>
      {index < itemsLength - 1 ? (
        <Button.Contained
          disabled={disabled}
          isLoading={isLoading}
          text={t('WidgetPipline.NextBtnKey')}
          type='submit'
        />
      ) : null}
      {index > 0 ? (
        <Button.Outlined
          {...backButtonProps}
          isLoading={isLoading}
          text={t('WidgetPipline.PreviousBtnKey')}
          onClick={handleClickPrevious}
        />
      ) : null}
    </div>
  )
}

export default WidgetPipelineActions
